import { LabelImportantOutlined } from '@mui/icons-material';
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, FormLabel, Stack, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';

export default function FootprintCategoryTab({ showInfo, selectedFootprintCategories, handleCategoryChange }) {
    return (
        <>
        <Grid2 xs={12} sm={6}>
            <Box className='centered-container mcc-tabinfo' >
            <Stack spacing={1} textAlign={'center'}>
                <Typography variant='h4' sx={{ fontWeight: '500 !important' }} color={"var(--mcc-contrast1)"}>
                    Footprint Categories
                </Typography>
            </Stack>
            </Box>
        </Grid2>
        <Grid2 xs={12} sm={6} className="horizontally-centered">
            <Box className="form-field" sx={{ p: 2, width: '100%' }}>
                <FootprintCategoriesCheckbox
                    selectedFootprintCategories={selectedFootprintCategories}
                    handleCategoryChange={handleCategoryChange}
                />
                { showInfo &&
                    <FootprintCategoriesInfo />
                }
            </Box>
        </Grid2>
        </>
    )
}

// Separate component for the checkbox group
const FootprintCategoriesCheckbox = ({ selectedFootprintCategories, handleCategoryChange }) => {
    return (
        <FormControl component="fieldset" variant="standard" required={true}>
            <FormLabel component="legend">I want to calculate the carbon footprint of:</FormLabel>
            <FormGroup>
                <FormControlLabel
                    control={
                        <Checkbox checked={selectedFootprintCategories?.onsite} onChange={(e) => handleCategoryChange(e, "onsite")} name="onsite" />
                    }
                    label="Onsite Activities (event venue, catering, waste, etc.)"
                />
                <FormControlLabel
                    control={
                        <Checkbox checked={selectedFootprintCategories?.transport} onChange={(e) => handleCategoryChange(e, "transport")} name="transport" />
                    }
                    label="Transportation (international and local travel)"
                />
                <FormControlLabel
                    control={
                        <Checkbox checked={selectedFootprintCategories?.accommodations} onChange={(e) => handleCategoryChange(e, "accommodations")} name="accommodations" />
                    }
                    label="Accommodations (hotel stay)"
                />
            </FormGroup>
            <FormHelperText>Select all that apply.</FormHelperText>
        </FormControl>
    )
};
const FootprintCategoriesInfo = () => {
    return (
        <Box sx={{ backgroundColor: 'var(--bg-green)', mt: 2, p: 1, color: '#00470F' }}>
            <Typography fontWeight={700}><LabelImportantOutlined fontSize='inherit' /> Important Note!</Typography>
            <Typography variant='body2'>
                Based on the <b>General Information</b> you provided, average values have been estimated and pre-filled for the sections you have selected above. You may use these defaults if the actual parameters are unknown. However, if you prefer to exclude a parameter from the overall calculation, please enter 0 in the corresponding field.
                <br/>
                <br/>
                Select at least one category above, then click <b>Next</b> to proceed with entering more detailed inputs for your event.
            </Typography>
        </Box>
    )
};